import Vue from 'vue';

const currentWindowSize = Vue.observable({
	width: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
	height: Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
});

/* Gives us an idea at all times what the size of the window is */
function handleResizeEvent() {
	Vue.set(currentWindowSize, 'width', Math.max(document.documentElement.clientWidth, window.innerWidth || 0));
	Vue.set(currentWindowSize, 'height', Math.max(document.documentElement.clientHeight, window.innerHeight || 0));
}

// Now add the actual listeners
if (window.addEventListener) {
	window.addEventListener('resize', handleResizeEvent, false);
} else if (window.attachEvent) {
	window.attachEvent('onresize', handleResizeEvent);
}

// Initialize
handleResizeEvent();

// Make it available to all components
Vue.mixin({
	computed: {
		windowSize() {
			return currentWindowSize;
		}
	}
});
